import { Component, Input, Renderer2, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ups-list-resize',
    template: require('./ups-list-resize.component.html')
})
/** ups-list-resize component*/
export class UpsListResizeComponent {


    @Input() columnsResize: any;
    @Output() private moveResult: EventEmitter<any> = new EventEmitter();
    start: any = undefined;
    pressed: boolean = false;
    startX: any;
    startWidth: any;
    resizableFnMousemove: () => void;
    resizableFnMouseup: () => void;
    startObject: any;

    /** ups-list-resize ctor */
    constructor(private renderer: Renderer2) {

    }

    resizeTable(event: any, column: any, index: any) {
        this.start = event.target;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = column.width;
        this.startObject = column;
        this.initResizableColumns(index, column);
    }

    private initResizableColumns(index, column) {
        this.resizableFnMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed) {

                let width = this.startWidth + (event.pageX - this.startX);

                if (width < this.startObject.dataminwidth) {
                    return;
                }

                if (this.startObject.columnIndex !== column.columnIndex) {
                    return;
                }

                let num: any = 0;
                this.columnsResize.forEach((item) => {
                    if (!item.resizeButtonActive) {
                        num = item.width;
                    }
                    if (this.startObject.field === item.field) {
                        item.width = width;
                        num = num + item.width;
                        item.resizeButtonLimit = num;
                    }
                    if (this.startObject.field !== item.field && item.resizeButtonActive !== false) {
                        num = num + item.width;
                        item.resizeButtonLimit = num;
                    }
                });


                this.moveResult.emit(this.columnsResize);
            }
        });
        this.resizableFnMouseup = this.renderer.listen('document', 'mouseup', (event) => {
            if (this.pressed) {
                this.pressed = false;
            }
        });

    }
}

